import React, { useContext, useEffect, useState } from "react";
import Entete from "./dataset/Entete";
import { ThemeContext } from "./ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretUp,
} from "@fortawesome/free-solid-svg-icons";
import avis_dashboard_1 from "../assets/Images/avis_dashboard_1.webp";
import avis_dashboard_2 from "../assets/Images/avis_dashboard_2.webp";
import avis_dashboard_3 from "../assets/Images/avis_dashboard_3.webp";
import { CircularProgress } from "@mui/material";
import API from "../Authentification/apiAdmin";
// import "../../Styles/AdminDashbord/clients.css";

const safe = (value) => {
  if (value === null || value === undefined) return "Néant";
  if (typeof value === "string" && value.trim() === "") return "Néant";
  return value;
};


const Clients = () => {
  const { theme } = useContext(ThemeContext);
  const [stats, setStats] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem("adminToken");

    const fetchStats = async () => {
      try {
        const response = await API.get("/admin/clients/stats", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });

        console.log("Données reçues :", response.data);
        setStats(response.data);
      } catch (err) {
        console.error(
          "Erreur de chargement :",
          err.response?.data?.message || err.message
        );
      }
    };

    if (token) fetchStats();
  }, []);

  return (
    <div className="clients-page">
      <Entete title="Clients" />

      {!stats ? (
        <div className="text-center my-5">
          <CircularProgress />
        </div>
      ) : (
        <div>
          {/* Premier content */}

          <div className="">
            <div className="row mt-4 g-2">
              {/* Tous les clients */}
              <div
                className="col-4 col-md-2 me-md-2 mb-3 mb-md-0 shadow-sm border border-1 d-flex flex-column align-items-center justify-content-center"
                style={{
                  backgroundColor: theme === "dark" ? "black" : "white",
                }}
              >
                <img alt="" src={avis_dashboard_1} className="img-fluid w-50" />
                <h5 className="petit_titre fw-bold">{stats.total_clients}</h5>
                <h5 className="petit_titre">Tous les clients</h5>
              </div>

              {/* Nouveaux clients */}
              <div
                className="col-4 col-md-2 me-md-2 mb-3 mb-md-0 shadow-sm border border-1 d-flex flex-column align-items-center justify-content-center"
                style={{
                  backgroundColor: theme === "dark" ? "black" : "white",
                }}
              >
                <img alt="" src={avis_dashboard_2} className="img-fluid w-50" />
                <h5 className="petit_titre fw-bold">{stats.new_clients}</h5>
                <h5 className="petit_titre">Nouveaux clients</h5>
              </div>

              {/* Clients réguliers */}
              <div
                className="col-4 col-md-2 me-md-2 mb-3 mb-md-0 shadow-sm border border-1 d-flex flex-column align-items-center justify-content-center"
                style={{
                  backgroundColor: theme === "dark" ? "black" : "white",
                }}
              >
                <img className="img-fluid w-50" src={avis_dashboard_3} alt="" />
                <h5 className="petit_titre fw-bold">{stats.regular_clients}</h5>
                <h5 className="petit_titre">Clients réguliers</h5>
              </div>

              {/* Taux de conversion */}
              <div className="col-12 col-md shadow-sm border border-1">
                <h5 className="taux_moyen">Taux de conversion</h5>
                <div className="row g-2">
                  <div className="col-12 col-md-8">
                    <div className="table-responsive">
                      <table className="table mb-0">
                        <thead>
                          <tr>
                            <th scope="col" className="texte_brut">
                              Année
                            </th>
                            <th scope="col" className="texte_brut">
                              Clients
                            </th>
                            <th scope="col" className="texte_brut">
                              Pourcent
                            </th>
                            <th scope="col" className="texte_brut">
                              Revenu
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {stats.conversion_rate.map((item, index) => (
                            <tr key={index}>
                              <th scope="row" className="texte_brut">
                                {item.year}
                              </th>
                              <td className="texte_brut">{item.clients}</td>
                              <td className="texte_brut">{item.percent}%</td>
                              <td className="texte_brut">{item.revenue} FCFA</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="row">
                      <div className="col-6">
                        <p className="texte_brut fw-bold">
                          {stats.regular_clients}
                        </p>
                        <p className="texte_brut">Réguliers</p>
                        <span style={{ color: "green" }}>
                          <FontAwesomeIcon icon={faCaretUp} /> +
                          {stats.loyalty_rate.frequent}%
                        </span>
                      </div>
                      <div className="col-6">
                        <p className="texte_brut fw-bold">
                          {stats.new_clients}
                        </p>
                        <p className="texte_brut">Nouveaux</p>
                        <span style={{ color: "green" }}>
                          <FontAwesomeIcon icon={faCaretUp} /> +
                          {stats.loyalty_rate.new}%
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Deuxième content */}
          <div className="">
            <div className="row mt-4">
              <div
                className="col shadow-sm border border-1 p-2"
                style={{
                  backgroundColor: theme === "dark" ? "black" : "white",
                }}
              >
                <h5 className="petit_titre fw-bold mb-3">
                  Liste des clients ({stats.clients?.length || 0}) — triée par nombre de commandes
                </h5>

                <div className="table-responsive" style={{ maxHeight: "480px", overflowY: "auto" }}>
                  <table className="table table-hover mb-0">
                    <thead>
                      <tr>
                        <th scope="col" className="texte_brut">Nom</th>
                        <th scope="col" className="texte_brut">Prénom</th>
                        <th scope="col" className="texte_brut">Email</th>
                        <th scope="col" className="texte_brut">Téléphone</th>
                        <th scope="col" className="texte_brut">Adresse</th>
                        <th scope="col" className="texte_brut">Commandes</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stats.clients && stats.clients.length > 0 ? (
                        stats.clients.map((client) => (
                          <tr key={client.id}>
                            <td className="texte_brut">{safe(client.nom)}</td>
                            <td className="texte_brut">{safe(client.prenom)}</td>
                            <td className="texte_brut">{safe(client.email)}</td>
                            <td className="texte_brut">{safe(client.telephone)}</td>
                            <td className="texte_brut">{safe(client.adresse)}</td>
                            <td className="texte_brut fw-bold">{safe(client.commandes)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="texte_brut text-center">
                            Aucun client trouvé.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Clients;